import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Evento } from '../models/evento';
import { EventoService } from '../evento.service';


@Injectable({ providedIn: 'root'})



export class EventoDetalheResolver implements Resolve<Observable<Evento>>{
    
    constructor(private eventoService: EventoService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const idEvento = route.params.idEvento;        
        return this.eventoService.getEvento(idEvento);        
    }

}